<div
  class="d-flex align-items-center justify-content-center body"
  style="height: 100vh"
>
  <div class="container-img">
    <img src="assets/img/verificacion.jpg" alt="" />
  </div>
  <div class="container-form text-start d-flex align-items-center">
    <div>
      <h2 class="text-uppercase title">
        <span id="color_1">Doble</span> verificación
      </h2>
      <p class="subtitle">
        Se ha enviado un código de verificación a su correo
      </p>
      <div class="card mb-2 mt-2">
        <div class="card-header">Correo Electrónico</div>
        <div class="card-body text-dark text-center">
          <span>{{ parametros.email }}</span>
        </div>
      </div>
      <p class="subtitle info text-center">
        Escriba el código enviado en el siguiente espacio:
      </p>
      <input
        type="text"
        class="form-control"
        maxlength="5"
        placeholder="Código de verificación"
        [(ngModel)]="codigo"
        (keypress)="validateNumber($event)"
      />
      <div class="d-flex justify-content-between mt-3">
        <button
          [disabled]="codigo === ''"
          class="btn btn-success"
          (click)="verificarCod()"
        >
          Verificar
        </button>
        <button class="btn btn-success" (click)="sendOtp()">
          Enviar nuevamente
        </button>
        <button class="btn btn-success" (click)="back()">Cancelar</button>
      </div>
    </div>
  </div>
  <div class="footer-body"></div>
</div>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
<alert></alert>
